import React, { useContext } from "react"
import { StyleSheet, View } from "react-native"
import { ThemeContext } from "./utility/context/ThemeContext"
import { SkeletonBlock, SkeletonCircle, SkeletonGroup, SkeletonLine } from "./utility/skeleton"

export const SavingsImpactSkeleton = (): React.ReactElement => {
  const theme = useContext(ThemeContext)
  const { bgMain } = theme.theme.colors

  return (
    <View style={{ backgroundColor: bgMain }}>
      <SkeletonGroup>
        {/* Environmental Impact */}
        <View style={{ gap: 10 }}>
          <SkeletonLine width="55%" height={18} radius={10} />
          <SkeletonLine width="70%" height={12} radius={8} />
          <SkeletonBlock style={styles.envChart} radius={12} />

          {/* Equivalencies grid (approx ValueLabelCards) */}
          <SkeletonLine width="35%" height={14} radius={8} style={{ marginTop: 6 }} />
          <View style={styles.grid}>
            {new Array(4).fill(0).map((_, idx) => (
              <SkeletonBlock key={idx} style={styles.gridCard} radius={12} />
            ))}
          </View>
        </View>

        {/* Social Impact */}
        <View style={{ gap: 10, marginTop: 20 }}>
          <SkeletonLine width="40%" height={18} radius={10} />
          <View style={styles.socialRow}>
            <View style={{ alignItems: "center", justifyContent: "center", minWidth: 275 }}>
              <SkeletonCircle size={220} />
              <SkeletonLine width={120} height={14} radius={8} style={{ marginTop: 12 }} />
            </View>
            <View style={{ gap: 10, minWidth: 275 }}>
              {new Array(5).fill(0).map((_, idx) => (
                <View key={idx} style={{ flexDirection: "row", alignItems: "flex-start", gap: 8 }}>
                  <SkeletonCircle size={8} />
                  <SkeletonLine width="90%" height={12} radius={8} />
                </View>
              ))}
            </View>
          </View>
        </View>
      </SkeletonGroup>
    </View>
  )
}

const styles = StyleSheet.create({
  envChart: {
    width: "100%",
    height: 300,
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "stretch",
    rowGap: 10,
    columnGap: 10,
    paddingHorizontal: 10,
  },
  gridCard: {
    minWidth: 250,
    maxWidth: 300,
    alignSelf: "stretch",
    width: "100%",
    height: 72,
  },
  socialRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    width: "100%",
    justifyContent: "space-evenly",
  },
})

